<template>
  <div
    :class="{ 'item-boxes': !scrollable, 'item-boxes--scrollable': scrollable }"
  >
    <ItemBox
      v-for="item in items"
      :key="item.id"
      :link-url="item.linkUrl"
      :image-url="item.imageUrl"
      :brand-name="item.brandName"
      :item-name="item.itemName"
      :item-price="item.itemPrice"
      :is-including-tax="item.isIncludingTax"
      :has-multiple-item-skus="item.hasMultipleItemSkus"
      :sold-out="item.soldOut"
      :labels="item.labels || []"
      @click-item-box="onClickItemBox(item.id)"
    />
  </div>
</template>
<script>
import ItemBox from '../../atoms/item_boxes/ItemBox.vue'
export default {
  components: { ItemBox },
  props: {
    items: {
      type: Array,
      required: true
    },
    scrollable: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.$emit('mount')
    })
  },
  methods: {
    onClickItemBox(itemId) {
      this.$emit('click-item-box', itemId)
    }
  }
}
</script>
